import { render, staticRenderFns } from "./project-member.vue?vue&type=template&id=4ac017c3&scoped=true"
import script from "./project-member.vue?vue&type=script&lang=ts"
export * from "./project-member.vue?vue&type=script&lang=ts"
import style0 from "./project-member.vue?vue&type=style&index=0&id=4ac017c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac017c3",
  null
  
)

export default component.exports